// You can write your custom Javascript here
if(document.getElementsByClassName('discover-btn').length > 0){
  document.getElementsByClassName('discover-btn')[0].addEventListener('mouseover', () => {
    let discoverMenu = document.getElementsByClassName('menu--discover')[0].getElementsByClassName('dropdown__menu')[0]
    discoverMenu.style.borderTop = "1px solid #c8c8c8"
    discoverMenu.style.maxHeight = "1000px"
    document.getElementsByTagName('body')[0].classList.add('no-scroll');
  })
  document.getElementsByClassName('discover-btn')[0].addEventListener('mouseout', () => {
    let discoverMenu = document.getElementsByClassName('menu--discover')[0].getElementsByClassName('dropdown__menu')[0]
    discoverMenu.style.removeProperty('border-top');
    discoverMenu.style.removeProperty('max-height');
    document.getElementsByTagName('body')[0].classList.remove('no-scroll');
  })
}

setTimeout(() => {
  if(document.getElementsByClassName('ais-filters-btn').length > 0){
    document.getElementsByClassName('ais-filters-btn')[0].addEventListener('click', e => {
      document.getElementsByTagName('body')[0].classList.toggle('ais-filters-open')
    })
  }
}, 1000)

setTimeout(() => {
  if(document.getElementsByClassName('ais-Stats-text').length > 0){
    let el = document.getElementsByClassName('ais-Stats-text')[0];
    let textArr = el.innerHTML.split('</span>');
    el.innerHTML = textArr[0].replace(' found','') + '</span>'
    el.style.display = 'block';
  }

  if(document.getElementsByClassName('custom-ais-filter-btn').length > 0){
    let el = document.getElementsByClassName('custom-ais-filter-btn')[0];
    el.addEventListener('click', e => {
     document.getElementsByClassName('ais-facets-button')[0].click();
    })
  }
}, 500)